var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.named ? _c('div', [_vm.namedCharacter.originalCharaID ? _c('v-avatar', {
    attrs: {
      "size": _vm.size,
      "tile": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.originalcharactericon.format(_vm.namedCharacter.originalCharaID) + '.jpg'
    }
  })], 1) : _c('v-avatar', {
    attrs: {
      "size": _vm.size
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.charaicon.format(_vm.namedCharacter.primaryCharacterID) + '.jpg'
    }
  })], 1)], 1) : _vm.original ? _c('div', [_c('v-avatar', {
    attrs: {
      "size": _vm.size,
      "tile": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.originalcharactericon.format(_vm.id) + '.jpg'
    }
  })], 1)], 1) : _c('div', [_vm.frame || _vm.$s.characterIconFramed ? _c('div', {
    style: _vm.style
  }) : _c('v-avatar', {
    attrs: {
      "size": _vm.size
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.charaicon.format(this.id) + '.jpg'
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }